/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import styles from '../style/index.css'
import React from 'react'

interface PayloadRowProps {
  payloadKey: string
  value: any
}

export const PayloadRow = ({ payloadKey, value }: PayloadRowProps) => {
  const values = Array.isArray(value) ? value.map(normalizePayloadValue) : [normalizePayloadValue(value)]
  return (
    <div className={styles['log__cell-item']}>
      <div className={styles['log__cell-item__key']}>{payloadKey}</div>
      <div>
        {values.map((normalizedValue) => (
          <div className={styles['log__cell-item__row']}>{normalizedValue}</div>
        ))}
      </div>
    </div>
  )
}

export function normalizePayloadValue(value: any): string {
  if (typeof value === 'string') {
    return value;
  } else if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  return JSON.stringify(value);
}